// import { LoadingService } from './angular-loading.service';
import {Injectable} from '@angular/core';
import * as signalR from '@aspnet/signalr';
// import {WebApiUrlConfigService} from './http.service';
// import {LocalStorageService} from './local-storage.service';
// import {LOCAL_STORAGE_KEY, SIGNALR_RECONNECT_TIME_DURATION, SignalrOutput} from '../interface';
import {Observable, interval} from 'rxjs';
import { Subject } from 'rxjs';

@Injectable()
export class SignalrService {
  private userToken: Promise<string>;
  deviceConnection: any;
  userOperation: any;
  realTimeDataSubject = new Subject<any>();
  connectionStatusSubject = new Subject<any>();
  userOperationSubject = new Subject<any>();
  constructor() {
    //this.userToken = this.systemParameterApiService.getScadaToken();
    this.getUserOperationSubject().subscribe(res => {
      this.userOperation = res;
    })
  }

  startReceiveDeviceMessage(model) {
    //this.deviceConnection = this.getConnection(`scada/signalr/LiveDataHub`);
    this.deviceConnection.on('LiveData', (data: any) => {
      this.realTimeDataSubject.next(data);
    });
    this.deviceConnection.start().then(() => {
      this.deviceConnection.invoke('SubscribePaths', model.projectId, model.paths);
      this.connectionStatusSubject.next(true);
    });
    this.deviceConnection.onclose(() => {
      //this.connectionStatusSubject.next(false)
        if(this.userOperation){
          this.connectionStatusSubject.next(false)
          return
        }
        this.deviceConnection.start().then(() => {
        this.deviceConnection.invoke('SubscribePaths', model.projectId, model.paths);
        this.connectionStatusSubject.next(true);
      });
    });
  }

  getDeviceSubject(): Observable<any> {
    return this.realTimeDataSubject.asObservable();
  }

  disconnectDevice() {
    if (this.deviceConnection) {
      return this.deviceConnection.stop();
    }
  }

  subscribeTags(deviceSN, realtimeTags) {
    if (!this.deviceConnection) {
      return;
    }
    setTimeout(() => {
      this.deviceConnection.invoke('SubscribePaths', deviceSN, realtimeTags).then(data => {
      }).catch(data => {
      });
    }, 500);
  }

  /****************实时报警部分Start********************/

  // tslint:disable-next-line: member-ordering
  alarmConnection: any;
  // tslint:disable-next-line: member-ordering
  alarmDataSubject = new Subject<any>();
  alarmConnectionStatusSubject = new Subject<any>();

  /** 新建实时报警连接 */
  startReceiveAlarmMessage() {
    var projectId = localStorage.getItem('projectId')?.toString();
   // this.alarmConnection = this.getConnection(`scada/signalr/AlarmDataHub`);
    this.alarmConnection.off('AlarmData');
    this.alarmConnection.on('AlarmData', (data: any) => {
      this.alarmDataSubject.next(data);
    });

    this.alarmConnection.start().then(() => {
      this.alarmConnection.invoke('SubscribePaths', projectId);
      this.alarmConnectionStatusSubject.next(true);
    });

    this.alarmConnection.onclose(() => {
      //this.alarmConnectionStatusSubject.next(false);
      this.alarmConnection.start().then(() => {
        this.alarmConnection.invoke('SubscribePaths', projectId);
        this.alarmConnectionStatusSubject.next(true);
      });
  
    });
  }
  
  disconnectAlarm() {
    if (this.alarmConnection) {
      return this.alarmConnection.stop();
    }
  }

  getAlarmSubject(): Observable<any> {
    return this.alarmDataSubject.asObservable();
  }

  getUserOperationSubject(): Observable<any> {
    return this.userOperationSubject.asObservable();
  }

  /****************实时报警部分 End********************/

  // 获取signalr连接
  // getConnection(url) {
  //   const connection = new signalR.HubConnectionBuilder()
  //   .withUrl(url, {
  //     accessTokenFactory: () => this.userToken
  //   })
  //   .build();
  //   return connection;
  // }
}
